import React from 'react'
import { Card, Form, Select } from 'antd'


const OldPhoneSearchList = ({ data, handleOldPhone}) => {


    return (
        <Card style={{height:"100%"}}>
            <Form layout="vertical">
                <Form.Item style={{ marginBottom: 0 }} label="Old Phone" name="oldPhone">
                    <Select
                        style={{ width: "100%" }}
                        placeholder="Please choose old phone"
                        value={""}
                        options={
                            data &&
                            data.map((item) => ({ label: item.model_name, value: item.id }))
                        }
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? "")
                                .toLowerCase()
                                .localeCompare((optionB?.label ?? "").toLowerCase())
                        }
                        showSearch
                        notFoundContent={null}
                        allowClear
                        onChange={handleOldPhone}
                    />
                </Form.Item>
            </Form>
        </Card>
    )
}

export default OldPhoneSearchList